import { useAppSelector, useAppDispatch } from '../store/hooks';
import { logoutThunk } from '../store/middlewares/authThunk';

// ----------------------------------------------------------------------

const useAuth = () => {
  const dispatch = useAppDispatch();
  const auth = useAppSelector((state) => state.auth);

  const logout = async () => {
    await dispatch(logoutThunk());
  };

  return {
    ...auth,
    user: {
      ...auth,
      displayName: auth.displayName || auth.email || auth.phone || 'User'
    },
    method: 'redux',
    logout,
  };
};

export default useAuth;
